import { useState, useEffect } from 'react';
import api from '../middleware/api';
import API from '../routes/APIEndpoints';
import { useLoading } from '../context/LoadingContext';


const useFetchData = (url, page) => {

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true)
    const { startLoading, stopLoading } = useLoading()

    const isValidPath = (path) => {
        // Remove trailing slashes from the path
        const trimmedPath = path.replace(/\/+$/, '');

        // Check if the trimmed path matches any key in the API object
        for (const key of Object.values(API)) {
            const regex = new RegExp(`^${key.replace(/:\w+/g, '[^/]+')}$`);
            if (regex.test(trimmedPath)) {
                return true; // If there's a match, the path is valid
            }
        }

        return false; // If no match found, the path is invalid
    };

    useEffect(() => {
        const controller = new AbortController();

        const doFetch = async () => {
            if (!url) {
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            try {
                if (isValidPath(url)) {
                    const config = { signal: controller.signal };
                    if (page) config.params = { page };
                    const response = await api.get(url, config);

                    if (response.status === 204) {
                        setData(null);
                        setError('No content found');
                        return;
                    }

                    const isNestedData = response.data.data
                    if (isNestedData) {
                        setData(response.data.data)
                    } else {
                        setData(response.data)
                    }
                } else {
                    console.error(`Aucune URL correspondante trouvée pour : ${url}`);
                }
            } catch (err) {
                if (err.name === 'CanceledError' || err.name === 'AbortError') {
                    return;
                }
                console.warn(err.response?.data?.message || 'An error occurred while fetching data')
                console.error(err)
                const message = err.response?.data?.message || 'An error occurred while fetching data'
                err.message = message
                setError(err);
                setData(null)
            } finally {
                if (!controller.signal.aborted) {
                    setIsLoading(false);
                }
            }
        };

        doFetch();
        return () => controller.abort();
    }, [url, page]);

    useEffect(() => {
        if (isLoading) {
            startLoading()
        } else {
            stopLoading()
        }
    }, [isLoading]);

    return { data, error, isLoading, setData };
};

export default useFetchData;
